<template>
  <div class="c-app">
    <CWrapper>
      <TheNavbar />
      <div class="c-body">
        <main class="c-main">
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
    <FlashToaster />
  </div>
</template>

<script>
import TheFooter from "./TheFooter.vue";
import TheNavbar from "@/containers/TheNavbar";

export default {
  name: "TheContainer",
  components: {
    TheFooter,
    TheNavbar,
  },
  computed: {
    errorResponseComponent() {
      return this.$store.state.errorResponseComponent;
    },
    fixedToasts() {
      return this.$store.state.fixedToasts;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
